var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsDeSelectAllWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.231,
    height: 20.172,
    viewBox: "0 0 26.231 20.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30677",
    "data-name": "Group 30677",
    transform: "translate(-213 -2359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7911",
    "data-name": "Rectangle 7911",
    width: 20,
    height: 3,
    transform: "translate(213 2365.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7912",
    "data-name": "Rectangle 7912",
    width: 20,
    height: 3,
    transform: "translate(213 2359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7913",
    "data-name": "Rectangle 7913",
    width: 12,
    height: 3,
    transform: "translate(213 2371.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16757",
    "data-name": "Path 16757",
    d: "M13.757,5.95l-.969-1.057L9.33,8.058,6.064,4.721,5,5.766,8.187,9.224,5,12.682l1.064,1.025L9.33,10.323l3.458,3.231.969-1.156L10.533,9.224Z",
    transform: "translate(224.784 2364.758)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsDeSelectAllWhiteIcon);
export default __webpack_public_path__ + "static/media/gs-de-selectAll-whiteIcon.d87424dcea40b7d14010f885cff4df48.svg";
export { ForwardRef as ReactComponent };